import styled from 'styled-components';
import palette from '@mlc/mlc-palette';
import { FontFamily, Color, ScreenSize } from '../../../../../enums';
import TrackableAnchor from '../../../../common/Anchor/TrackableAnchor';

export const Li = styled.li`
	border: ${Color.border};
	border-style: solid;
	border-width: 0 0 1px;
	display: flex;
	flex: 1;
	list-style: none;
	margin: 0;
	padding: 0;

	&:last-child {
		border-width: 0;
	}

	@media (max-width: ${ScreenSize.small}) {
		flex: none;
	}
`;

export const RightChevron = styled.span`
	color: ${palette.mlcText};
	display: flex;
	flex: 1;
	justify-content: flex-end;
	padding-right: 1rem;
	text-align: right;
`;

export const UnreadNotification = styled.span`
	align-items: center;
	background-color: ${palette.mlcOrange};
	border-radius: 1rem;
	color: ${palette.mlcWhite};
	display: flex;
	font-family: ${FontFamily.charlieBold};
	justify-content: center;
	line-height: 1.1;
	margin: 0 0.5rem !important;
	padding: 0 0.4rem;
	text-decoration: none;
	text-decoration-color: ${palette.mlcOrange};
`;

export const Anchor = styled(TrackableAnchor)`
	align-items: center;
	box-sizing: border-box;
	color: ${palette.mlcText};
	color: ${palette.mlcText};
	display: flex;
	flex: 1;
	height: 100%;
	justify-content: space-between;
	padding: 15px;
	text-decoration: none;

	:focus,
	:hover {
		background-color: ${palette.mlcKoala};
	}

	&:focus p,
	&:hover p {
		color: ${palette.mlcTextLink};
		text-decoration: underline;
	}

	&:focus ${RightChevron}, &:hover ${RightChevron} {
		color: ${palette.mlcTextLink};
	}
`;

export const Icon = styled.img`
	padding-right: 0.5rem;
`;
